/* Schneider Solutions Probiotika-Konfigurator: reine Berechnungslogik */
(function (root) {
  "use strict";

  function createCalculator(data) {
    if (!data) throw new Error("PROBLIFE_DATA fehlt");

    const pricing = data.pricing;
    const capsuleConstants = data.capsuleConstants;
    const strains = data.strains;
    const maxStrainsByPotency = data.maxStrainsByPotency;

    function cfuBillionNumeric(potency) {
      if (potency === "5B") return 5;
      if (potency === "10B") return 10;
      if (potency === "15B") return 15;
      return 0;
    }

    function findStrain(id) {
      return strains.find(function (strain) { return strain.id === id; });
    }

    function maxStrainsAllowed(potency) {
      return Number(maxStrainsByPotency[potency] || 0);
    }

    function calcFillWeight(config) {
      const potency = config.potency;
      const strainIds = Array.isArray(config.strainIds) ? config.strainIds : [];
      if (!potency || !strainIds.length) return null;

      const totalCFU = cfuBillionNumeric(potency);
      const perStrainCFU = totalCFU / strainIds.length;
      let strainMg = 0;

      strainIds.forEach(function (id) {
        const strain = findStrain(id);
        if (!strain) return;
        strainMg += (perStrainCFU / strain.potencyBg) * 1000 * 1.3;
      });

      const fosMg = capsuleConstants.fosFlatMg;
      const flowMg = capsuleConstants.flowAgentsMg;
      const activeWeight = strainMg + fosMg + flowMg;
      const mccMg = Math.max(
        capsuleConstants.mccMinFloorMg,
        capsuleConstants.capsuleTargetFillMg - activeWeight
      );

      return {
        totalFillMg: strainMg + fosMg + mccMg + flowMg,
        perStrainCFU: perStrainCFU,
        strainMg: strainMg,
        mccMg: mccMg
      };
    }

    function assignCapsule(config) {
      const fill = calcFillWeight(config);
      if (!fill) return null;
      if (fill.totalFillMg <= capsuleConstants.size0MaxFillMg) return "0";
      if (fill.totalFillMg <= capsuleConstants.size00MaxFillMg) return "00";
      return "error";
    }

    function calcCapsulePrice(config) {
      const perCap = pricing.perCapLanded[config.potency];
      if (!perCap || !config.capsCount || !config.tier) return null;

      const capsuleSize = assignCapsule(config);
      if (!capsuleSize || capsuleSize === "error") return null;

      const fixed = pricing.bulgariaFixed;
      const bottle = capsuleSize === "00" && Number(config.capsCount) === 60
        ? fixed.bottle150ml
        : fixed.bottle100ml;
      const fixedPerBottle =
        bottle + fixed.closure38mm + fixed.label + fixed.bottling + fixed.qc;
      const perBottle = perCap * Number(config.capsCount) + fixedPerBottle;

      return {
        selfCostPerBottle: perBottle,
        selfCostTotal: perBottle * Number(config.tier),
        capsuleSize: capsuleSize
      };
    }

    function buildOrderPayload(type, config) {
      const price = calcCapsulePrice(config);
      if (!price) return null;
      return {
        productLine: type,
        potency: config.potency,
        capsCount: config.capsCount,
        tier: config.tier,
        strainIds: config.strainIds,
        selfCostPerBottle: price.selfCostPerBottle,
        selfCostTotal: price.selfCostTotal
      };
    }

    function buildShopifyProperties(payload) {
      return {
        "Produktlinie": payload.productLine,
        "Wirkstärke": payload.potency,
        "Kapseln": payload.capsCount,
        "Menge": payload.tier,
        "_konfigurator_payload": JSON.stringify(payload)
      };
    }

    return {
      maxStrainsAllowed: maxStrainsAllowed,
      calcFillWeight: calcFillWeight,
      assignCapsule: assignCapsule,
      calcCapsulePrice: calcCapsulePrice,
      buildOrderPayload: buildOrderPayload,
      buildShopifyProperties: buildShopifyProperties
    };
  }

  root.PROBIOTIK_LOGIC = { createCalculator: createCalculator };
})(window);
